export const defaultItemsPerPage = 25;
export const maxItemsPerPage = 500;
